import React from 'react';

const Callout = ({ variant = 'info', children, className = '' }) => {
  const baseClasses = 'callout';
  const variantClasses = {
    info: 'callout-info',
    warn: 'callout-warn',
    success: 'callout-success'
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
};

export default Callout;
